import styled from 'styled-components'
import {
  mediaMax,
  calculateResponsiveSize,
  themeColor
} from '@dboxdev/ui-components'

export const Wrapper = styled.footer`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: ${calculateResponsiveSize(300)};
  padding: ${calculateResponsiveSize(85)} 0 0;
  color: ${themeColor('accentColor')};
  ${mediaMax('mobile')} {
    height: ${calculateResponsiveSize(190)};
    padding: ${calculateResponsiveSize(60)} 0 0;
  }
`

export const Links = styled.div`
  margin: 0 0 ${calculateResponsiveSize(58)};
  text-align: center;
  font-size: ${calculateResponsiveSize(18)};
  line-height: 1.334;
  letter-spacing: ${calculateResponsiveSize(0.432)};
  text-transform: uppercase;
  white-space: nowrap;
  && a, && a:hover {
    color: inherit;
  }
  ${mediaMax('mobile')} {
    margin: 0 0 ${calculateResponsiveSize(30)};
    font-size: ${calculateResponsiveSize(10)};
    letter-spacing: ${calculateResponsiveSize(0.233)};
  }
`

export const EqualHousing = styled.div`
  width: ${calculateResponsiveSize(50)};
  svg {
    display: block;
    width: 100%;
    height: auto;
  }
  ${mediaMax('mobile')} {
    width: ${calculateResponsiveSize(26)};
  }
`
